// Generated by `npm run data:mesophotic` (scripts/data/mesophotic.ts) from data/fukunaga-2016-nwhi/ (Fukunaga et al. 2016, CC0). Do not edit by hand.
// tests/visits.test.ts builds it again from the archive.
import type { FishSpeciesId } from '../../fish';

/**
 * Each reef fish's density on the hard bottom of 30 m and deeper over its density on the reef's 0 to 30 m: its mean fish
 * a 100 m² over every site of each side, at the Northwestern Hawaiian Islands, 2010 to 2012 (in each row's comment).
 */
export const SLOPE_PER_REEF: Readonly<Partial<Record<FishSpeciesId, number>>> = {
  bullethead: 0.145319, // 0.243902 on 4 of 82 sites over 1.67839 on 57 of 118
  palenose: 0.820113, // 0.365854 on 1 of 82 sites over 0.446102 on 20 of 118
  roi: 0, // 0 on 0 of 82 sites over 0.00957627 on 3 of 118
  kala: 0.163001, // 0.146341 on 1 of 82 sites over 0.897797 on 69 of 118
  ulua: 1.10323, // 0.390244 on 8 of 82 sites over 0.353729 on 24 of 118
  omilu: 3.5327, // 0.780488 on 6 of 82 sites over 0.220932 on 35 of 118
  redlip: 0, // 0 on 0 of 82 sites over 0.155593 on 15 of 118
  nenue: 0, // 0 on 0 of 82 sites over 1.06737 on 34 of 118
  moanokea: 2.93951, // 0.268293 on 6 of 82 sites over 0.0912712 on 19 of 118
  manini: 0, // 0 on 0 of 82 sites over 5.24678 on 85 of 118
};
